const INITIAL_STATE = {
  selectedStore: null,
  stores: [],
  storesAccess: [],
  expand: false
}

export const Creators = {
  setEconomicGroups: (data) => ({
    type: 'SET_ECONOMIC_GROUPS',
    stores: data,
  }),
};

export default function economicGroupReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'SET_ECONOMIC_GROUPS':
      return {
        ...state,
        stores: action.stores
      }
    case 'SET_STORE_ACCESS': 
      return {
        ...state,
        storesAccess: action.stores
      }
    case 'SET_SELECTED_STORE': 
      return {
        ...state,
        selectedStore: action.selectedStore
      }
    case 'SET_EXPAND': 
      return {
        ...state,
        expand: action.expand
      }
    case 'RESET':
      return {
        stores: []
      }
    default:
      return state;
  }
}
